import React from 'react'
import ReactDOM from 'react-dom/client'
import './i18n/index'
import App from './App'
import { ThemeModeProvider } from './contexts/ThemeModeContext'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ThemeModeProvider>
      <App />
    </ThemeModeProvider>
  </React.StrictMode>,
)
